var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', {
    attrs: {
      "offset": "0",
      "open": _vm.isOpen,
      "trigger": "click",
      "autoHide": true
    },
    on: {
      "auto-hide": _vm.close
    }
  }, [_c('span', {
    staticClass: "tooltip-target",
    attrs: {
      "data-testid": "client-banner-psa"
    },
    on: {
      "click": _vm.open
    }
  }, [(_vm.client.sorted_measurement_records && _vm.client.sorted_measurement_records.psa) ? [_c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'měřeno: <b>' + _vm.client.sorted_measurement_records.psa.data[0].measure_date + '</b>',
        placement: 'bottom-center',
        classes: ['info']
      }),
      expression: "{\n                    content: 'měřeno: <b>' + client.sorted_measurement_records.psa.data[0].measure_date + '</b>',\n                    placement: 'bottom-center',\n                    classes: ['info']}"
    }],
    staticClass: "badge badge-primary",
    attrs: {
      "data-testid": "client-psa-badge"
    }
  }, [_c('strong', [_vm._v("PSA:")]), _vm._v(" " + _vm._s(_vm.client.sorted_measurement_records.psa.data[0].value) + " " + _vm._s(_vm.client.sorted_measurement_records.psa.measurand.unit) + "\n            ")])] : _vm._e()], 2), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(_vm.client.sorted_measurement_records && _vm.client.sorted_measurement_records.psa) ? _c('div', {
    staticClass: "container tooltip_container tooltip_1_5_col",
    attrs: {
      "data-testid": "client-psa-popover"
    }
  }, [_c('div', {
    staticClass: "row tooltip_header"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._v("PSA")])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._l((_vm.client.sorted_measurement_records.psa.data), function(record) {
    return [
      [_c('tr', {
        staticClass: "row m-0 text-left",
        attrs: {
          "data-testid": "client-psa-row"
        }
      }, [_c('td', {
        staticClass: "col-sm-6 text-left"
      }, [_c('strong', [_vm._v(_vm._s(record.value))]), _vm._v(" " + _vm._s(_vm.client.sorted_measurement_records.psa.measurand.unit))]), _vm._v(" "), _c('td', {
        staticClass: "col-sm-6 text-right"
      }, [_vm._v(_vm._s(record.measure_date))])]), _vm._v(" "), (record.note) ? _c('tr', {
        staticClass: "row m-0 no-top-border-td no-padding-top-td"
      }, [_c('td', {
        staticClass: "col-sm-1"
      }), _vm._v(" "), _c('td', {
        staticClass: "col-sm-11 font-italic text-left"
      }, [_c('span', {
        attrs: {
          "data-testid": "client-psa-note"
        }
      }, [_vm._v(_vm._s(record.note))])])]) : _vm._e()]
    ]
  })], 2)])])])]) : _vm._e()])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2589b611","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientPSA.vue
// module id = 324
// module chunks = 0